var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c(
          "div",
          { staticClass: "page-header-top-container" },
          [
            _c("div", { staticClass: "page-name" }, [
              _vm._v("\n                Draggable Video List\n            ")
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary waves-effect pull-right",
                attrs: {
                  title: "Add Video",
                  to: { name: "AddMedia", params: { slug: "video" } }
                }
              },
              [_vm._v("Add Video")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "cards-container" },
            [
              _c(
                "draggable",
                {
                  staticClass: "drag-view",
                  on: {
                    change: function($event) {
                      return _vm.changePosition()
                    }
                  },
                  model: {
                    value: _vm.imageList,
                    callback: function($$v) {
                      _vm.imageList = $$v
                    },
                    expression: "imageList"
                  }
                },
                [
                  _vm._l(_vm.imageList, function(text, index) {
                    return [
                      _c("div", { staticClass: "col-4 mb-5" }, [
                        _c("div", { staticClass: "cards-block" }, [
                          _c(
                            "div",
                            { staticClass: "card" },
                            [
                              text.type == "url"
                                ? [
                                    _c("img", {
                                      key: index,
                                      staticClass: "card-img-top",
                                      attrs: { src: "/static/images/video.jpg" }
                                    })
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              text.type == "video"
                                ? [
                                    _c("img", {
                                      key: index,
                                      staticClass: "card-img-top",
                                      attrs: { src: text.image }
                                    })
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "card-body" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "ml-2 mr-2 btn btn-danger pull-right",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.deleteVideo(text.id)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-trash",
                                        attrs: { "aria-hidden": "true" }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "ml-2 mr-2 btn btn-success pull-right",
                                      attrs: {
                                        to: {
                                          name: "PlayVideos",
                                          params: { id: text.id }
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-eye",
                                        attrs: { "aria-hidden": "true" }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  text.show_at_home == 0
                                    ? [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              " btn btn-success pull-right",
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.showHideFromHome(
                                                  text.id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Show at Home")]
                                        )
                                      ]
                                    : [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              " btn btn-danger pull-right",
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.showHideFromHome(
                                                  text.id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Hide from Home")]
                                        )
                                      ]
                                ],
                                2
                              )
                            ],
                            2
                          )
                        ])
                      ])
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7f36a04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7f36a04","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/gallery/ListVideos.vue
// module id = null
// module chunks = 